import React, { useEffect, useState } from 'react'
import Sidebar from '../../Components/Sidebar'
import TopHeader from '../../Components/TopHeader'
import { useNavigate, useParams, useSearchParams } from 'react-router'
import { useProjectStore } from '../../store/useProjectStore'
import Loader from '../../Components/Loader'
import { postProject } from '../../api/project'
import { useHomeStore } from '../../store/useHomeStore'

const MarketAreaform = () => {
    const navigate = useNavigate()

    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const { getMarketAreaById, addNewMarketArea } = useHomeStore()

    const [marketType, setMarketType] = useState("")
    const [title, setTitle] = useState("")
    const [image, setImage] = useState(null)
    const [loading, setLoading] = useState(false)
    const [description, setDescription] = useState("")

    const getImageSrc = (img) => {
        if (!img) return null;
        if (typeof img === "string") {
            return img;
        }
        return URL.createObjectURL(img);
    };

    const handleSubmit = async () => {

        const data = {
            title: title, image: image, description: description, id: id
        }
        setLoading(true)
        const res = await addNewMarketArea(data)
        setLoading(false)
        if (res) {
            navigate("/home")
        }

    }

    const getMarketAreaFunction = async () => {
        let data = await getMarketAreaById(id)
        setTitle(data?.title)
        setImage(data?.image)
        setDescription(data?.description)
    }

    useEffect(() => {
        if (id) {
            getMarketAreaFunction()
        }
    }, [id])
    return (
        <div id="admin-dashboard" className="flex h-[800px] bg-neutral-100">
            <Sidebar />
            <div id="main-content" className="flex-1 flex flex-col overflow-hidden">
                <TopHeader pageName="Project" />
                <div id="content-container" className="flex-1 overflow-auto p-6">
                    <div>
                        <div id="project-form" className="bg-white rounded-md shadow-sm border border-neutral-200 overflow-hidden mb-6">
                            <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50 flex justify-between items-center">
                                <h3>Add New Market Area</h3>
                                <button className="text-neutral-500 hover:text-neutral-700">
                                    <i className="fa-solid fa-times"></i>
                                </button>
                            </div>
                            <Loader loading={loading}>
                                <div className="p-6">
                                    <div className="grid grid-cols-1 gap-6 mb-6">
                                        <div>
                                            <label className="block text-sm text-neutral-700 mb-2">
                                                Title
                                            </label>
                                            <input
                                                type="text"
                                                value={title}
                                                onChange={(e) => setTitle(e.target.value)}
                                                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                                            />
                                        </div>

                                    </div>

                                    <div className="mb-6">
                                        <label className="block text-sm text-neutral-700 mb-2">Description</label>
                                        <textarea
                                            rows="4"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                                        ></textarea>
                                        <p className="text-sm text-gray-500 mt-1">
                                            {description?.length || 0}/1000 characters
                                        </p>
                                    </div>

                                    <div className="mb-6">
                                        <label className="block text-sm text-neutral-700 mb-2">Image</label>
                                        <div className="border-2 border-dashed border-neutral-300 rounded-md p-6 flex flex-col items-center justify-center">
                                            <i className="fa-solid fa-cloud-upload-alt text-3xl text-neutral-400 mb-2"></i>
                                            <p className="text-neutral-600 mb-2">Drag and drop an image here, or click to browse</p>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => setImage(e.target.files[0])}
                                                className="hidden"
                                                id="areaImage"
                                            />
                                            <label
                                                htmlFor="areaImage"
                                                className="px-4 py-2 bg-neutral-100 text-neutral-700 rounded-md text-sm cursor-pointer"
                                            >
                                                Select File
                                            </label>
                                            {image && <p className="mt-2 text-sm text-green-600">{image.name}</p>}
                                            <div className="w-44 h-26 flex items-center justify-center text-white text-xs mr-4">
                                                {getImageSrc(image) ? (
                                                    <img
                                                        src={getImageSrc(image)}
                                                        alt="Hero"
                                                        className="w-full h-full object-cover"
                                                    />
                                                ) : (
                                                    'No Image'
                                                )}
                                            </div>
                                        </div>
                                        <span className='text-sm font-medium text-gray-700'>Recomended Image Size : 800px*600px</span>
                                    </div>

                                    <div className="flex justify-end space-x-3">
                                        <button className="px-4 py-2 border border-neutral-300 text-neutral-700 rounded-md"
                                            onClick={() => navigate(-1)}
                                        >Cancel</button>
                                        <button
                                            className="px-4 py-2 bg-neutral-900 text-white rounded-md"
                                            onClick={() => handleSubmit()}
                                        >
                                            Save Market Area
                                        </button>
                                    </div>
                                </div>
                            </Loader>
                        </div>
                    </div>
                </div >
            </div >
        </div >
    )
}

export default MarketAreaform
